<template>
  <div class="container">
    <TopHead :is-back-white="true" />
    <div class="ms_banner" />
    <div class="ms_con">
      <van-pull-refresh
        v-model="loading"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :immediate-check="false"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            v-for="(item,index) in list"
            :key="index"
            class="ms_item d_f ali_c"
          >
            <van-image
              fit="cover"
              :src="item.coverImgUrl"
            >
              <template #loading>
                <img
                  src="../assets/img/img_loading.png"
                  alt=""
                >
              </template>
            </van-image>
            <div class="flex_1 d_f ali_c msi_ri_te">
              <div class="flex_1 over_h" style="margin-right: 15px">
                <div class="msi_ti">
                  {{ item.name }}
                </div>
                <div class="d_f table_out">
                  <div class="flex_1">
                    <div class="d_f">
                    <span class="table_ti text_over">
                      地址：
                    </span>
                      <span class="ms_address flex_1">
                      {{ item.address }}
                    </span>
                    </div>
                    <div class="d_f">
                    <span class="table_ti">
                      电话：
                    </span>
                      <span>{{ item.phone }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div>
                  <a class="t_a" @click="goMap(item)">
                    <img src="../assets/img/ms_map.png" alt="">
                  </a>
                </div>
                <a class="t_a" :href="'tel:'+item.phone">
                  <img src="../assets/img/ms_call.png" alt="" style="margin-bottom: 0">
                </a>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
    export default {
        name: "serviceHotel",

      data() {
        return {
          refreshing:false,
          loading:true,
          finished:false,
          list:[],
          params:{
            pageSize:10,
            pageIndex:1,
          }
        }
      },
      created(){
        this.listLoad()
      },
      methods: {
        //点击去这里打开地图
        goMap(row){
          let name = row.name || row.siteName;
          let locations = this.$global.loactions ? this.$global.loactions :null;
          if(!locations) return this.$toast('定位失败，无法导航');
          let ipGo = `https://uri.amap.com/navigation?from=${locations[0]},${locations[1]},起点&to=${row.longitude},${row.latitude},${name}&callnative=1`;
          this.goAppOut(ipGo)
        },
        goAppOut(url){
          console.log(encodeURI(url))
          if(this.$global.modelState){
            window.android.openBrowser(`${encodeURI(url)}`);
          }else {
            this.$iosMethod(function(bridge) {
              bridge.callHandler('openBrowser', JSON.stringify({url:encodeURI(url)}),function(data) {
              })
            })
          }
        },
        listLoad(){
          this.loading = true;
          this.$api.hotelDirectory(this.params).then(res => {
            this.loading = false;
            if (this.refreshing) {
              this.refreshing = false;
            }
            if(res.data.recordCount){
              this.list = this.list.concat(JSON.parse(JSON.stringify(res.data.rows)));
            }
            let list = res.data.rows;
            if (!list || list.length < this.params.pageSize) {
              this.finished = true;
            }
          })

        },
        onRefresh(){
          this.list = [];
          this.finished = false;
          this.params.pageIndex = 1;
          this.listLoad();
        },
        onLoad(){
          let me = this;
          let page = me.params.pageIndex;
          page = page ? page + 1 : 1;
          this.params.pageIndex = page;
          this.listLoad();
        },
      }
    }
</script>

<style scoped lang="scss">
  .ms_item{
    .msi_ri_te{
      .table_out{
        align-items: flex-end;
      }
      .ms_address{
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        /*height: 60px;*/
        box-sizing: border-box;
        vertical-align: top;
        margin-bottom: 15px;
      }
      .table_ti{
        width: 80px;
        vertical-align: top;
      }
      a.t_a{
        img{
          width: 41px;
          height: 41px;
          font-size: 0;
          margin-bottom: 41px;
        }
        position: relative;
        top: -3px;
        font-size: 20px;
        font-weight: 500;
        color: #4C90F1;
        text-decoration: none;
        width: 130px;
      }
      table{
        td{
          padding: 0;
        }
        font-size: 22px;
        font-weight: bold;
        color: #6E6E6E;
        line-height: 36px;
      }
      .msi_ti{
        font-size: 32px;
        font-weight: bold;
        color: #3E3E3E;
        margin-bottom: 18px;
      }
      padding-bottom: 19px;
      padding-left: 17px;
      border-bottom: 1px solid #D8D8D8;
      height: 200px;
    }
    .van-image{
      width: 240px;
      height: 200px;
      margin-right: 9px;
      border-radius: 10px;
      overflow: hidden;
    }
    margin-bottom: 39px;
  }
  .ms_con{
    padding: 31px 25px;
  }
  .ms_banner{
    height: 347px;
    background: url("../assets/img/ms_banner_hotel.png") no-repeat center center;
    background-size: 100% 100%;
  }
</style>
